import OrderDocumentService from '@/services/retailer/OrderDocumentService'
import { errorMessage } from '@/utilities/helpers'

export const namespaced = true

export const state = {
  documents: [],
  document: null,
  qrInfo: null
}

export const mutations = {
  SET_DOCUMENTS(state, documents) {
    state.documents = documents.data
  },
  SET_DOCUMENT(state, document) {
    state.document = document.data
  },
  SET_QR_INFO(state, qrInfo) {
    state.qrInfo = qrInfo
  }
}

export const actions = {
  viewDocument({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      OrderDocumentService.viewDocument(params.documentId, params.mimeType)
        .then(response => {
          commit('SET_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  generateQrCode({ commit, dispatch }, params) {
    commit('SET_QR_INFO', null)
    return new Promise((resolve, reject) => {
      OrderDocumentService.generateQrCode(params.orderId)
        .then(response => {
          commit('SET_QR_INFO', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
